module.exports = __webpack_public_path__ + "img/filterimg.b80b26b6.svg";